import { TypedDocumentNode, gql } from '@apollo/client'

import { DRUG_NAME_FRAGMENT } from '../drugInfo'

import { DrugInfoResult, DrugInfoVariables } from './types'

export const DRUG_INFO_QUERY: TypedDocumentNode<
  DrugInfoResult,
  DrugInfoVariables
> = gql`
  query drugInfo($drugName: String!) {
    drugInfo: flatSingleDrugConfiguration(name: $drugName) {
      kind: __typename
      ...drugInfo
      ...drugRejection
    }
  }

  fragment drugInfo on SingleFlatDrugConfiguration {
    drug {
      ...drugName
      isAlternativesOnly: alternativesOnly
    }
    alternatives {
      ...drugName
    }
  }

  fragment drugRejection on DrugRejection {
    type: reject_type
    message: reject_message
    description: reject_description
  }

  ${DRUG_NAME_FRAGMENT}
`
